import { validateApiModule } from "./validate-api";
import user from "./modules/user/index.js";
// import article from "./modules/article/index.js"; // 手写版保留，已切换生成版
import article from "./generated/article.js";
import cases from "./modules/case/index.js";
// import doc from "./modules/doc/index.js";
import doc from "./generated/doc.js";
import video from "./modules/video/index.js";
import poster from "./modules/poster/index.js";
import product from "./modules/product/index.js";
import solution from "./modules/solution/index.js";
import subject from "./modules/subject/index.js";
import wall from "./modules/wall/index.js";
// import featured from "./modules/featured/index.js";
import featured from "./generated/featured.js";
import tracking from "./modules/tracking/index.js";
import activity from "./modules/activity/index.js";
import enterprise from "./modules/enterprise/index.js";
import marketing from "./modules/marketing/index.js";
import channel from "./modules/channel/index.js";
import wechat from "./modules/wechat/index.js";
import common from "./modules/common/index.js";
import autoweb from "./modules/autoweb/index.js";
import clue from "./modules/clue/index.js";
import website from "./modules/website/index.js";
// import form from "./modules/form/index.js";
// import questionnaire from "./modules/questionnaire/index.js"; // 手写版保留，已切换生成版]
import form from "./generated/form.js";
import questionnaire from "./generated/questionnaire.js";
import tenant from "./modules/tenant/index.js";
import home from "./modules/home/index.js";
import upload from "./modules/upload/index.js";
import menu from "./modules/menu/index.js";
import intentScoring from "./modules/intent/index.js";
import basic from "./modules/basic/index.js";
import qyyx from "./modules/qyyx/index.js";
import email from "./modules/email/index.js";
import message from "./modules/message/index.js";
import material from "./modules/material/index.js";

const api = {
  user,
  article,
  cases,
  doc,
  video,
  poster,
  product,
  solution,
  subject,
  wall,
  featured,
  tracking,
  activity,
  marketing,
  channel,
  wechat,
  autoweb,
  clue,
  website,
  form,
  common,
  enterprise,
  questionnaire,
  tenant,
  home,
  upload,
  menu,
  intentScoring,
  basic,
  qyyx,
  email,
  message,
  material,
};

// 开发环境启用运行时守卫
if (process.env.NODE_ENV === 'development') {
  validateApiModule(api);
}

export default api;
